<template>
  <v-container grid-list-xl>
    <h2 class="display-1">Prüfungsset ändern</h2>
    <v-flex>
      <EditSetComponent
        :set="set"
        :verfahren="verfahren"
        :arten="arten"
        :sektoren="sektoren"
        @onSave="saveSet"
        @onUploadImage="saveImage"
      />
    </v-flex>
  </v-container>
</template>

<script>
import EditSetComponent from './EditSetComponent';

export default {
  name: 'EditSetPage',
  props: ['setId'],
  data() {
    return {
      isLoading: true,
      loadingProgress: 0,
      arten: [],
      sektoren: [],
      verfahren: [],
      set: {}
    };
  },
  mounted() {
    this.loadData(this.setId);
  },
  methods: {
    async loadData(setId) {
      try {
        this.isLoading = true;

        const [set, verfahren, arten, sektoren] = await Promise.all([
          this.$http.get(`pruefungsset/${setId}`),
          this.$http.get('verfahren'),
          this.$http.get('produktart'),
          this.$http.get('industriesektor')
        ]);

        this.set = set.body;
        this.verfahren = verfahren.body;
        this.arten = arten.body;
        this.sektoren = sektoren.body;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    saveSet(set) {
      console.log(set);
      if (set.ID > 0) {
        this.$http
          .put(`pruefungsset/${set.ID}`, set)
          .then(resp => {
            this.$router.push({ name: 'SingleSet', params: { setId: set.ID } });
          })
          .catch(err => console.error(err));
      }
    },
    saveImage(file) {
      console.log(file);
      if (this.set.ID > 0) {
        this.$http
          .post(`pruefungsset/${this.set.ID}/img`, file)
          .then(resp => {
            this.loadData(this.set.ID);
          })
          .catch(err => console.error(err));
      }
    }
  },
  components: {
    EditSetComponent
  }
};
</script>
